export default __webpack_public_path__ + "static/media/drush.47418bd2.jpg";